import React from 'react';
import Grid from '@cx/ui/Grid';
import Col from '@cx/ui/Col';
import Panel from 'react-bootstrap/lib/Panel';

const HomePage = () => {
  return (
    <Grid fluid className="template-page-wrapper page-wrapper__content-only">
      <Col sm={12} md={12} lg={12}>
        <Panel>
          <div className="template-content-wrapper content-wrapper__content-only">
            <h1>{"Welcome to VINCE's CARVIM!"}</h1>
            <p>This site implements the vince-ui widgets as an external application, using the same patterns intended for other Cox Automotive websites. This will help demo the actual widgets against the actual endpoints, keep the CARVIM teams honest with regard to other users of the widgets, and be a single location for anyone to view our progress.</p>
            <p>Please reference the document below for more information, or contact the CARVIM teams.</p>
            <ul>
              <li>
                <a href="https://ghe.coxautoinc.com/Cox-CarVim/vince-ui/wiki">Widget Integration Docs (GHE)</a>
              </li>
            </ul>
          </div>
        </Panel>
      </Col>
    </Grid>
  );
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.js